export default {
  title01: "สภาพอากาศปัจจุบัน",
  title02: "24 ชั่วโมง",
  title03: "พยากรณ์อากาศใน 10 วัน",
  title04: "AQI",
  title05: "ดูข้อมูลทั้งหมด",
  title06: "ดวงอาทิตย์ขึ้นและดวงอาทิตย์ตก",
  title07: "ข้างขึ้นข้างแรมของดวงจันทร์",
  title08: "จันทร์เต็มดวง",
  title09: "แรม 15 ค่ำ",
  title10: "กลางวัน",
  title11: "กลางคืน",
  title12: "อาทิตย์ขึ้น",
  title13: "อาทิตย์ตก",
  title14: "ดวงจันทร์ขึ้น",
  title15: "ดวงจันทร์ตก",
  title16: "แหล่งข้อมูล",
  title17: "เริ่ม",
  title18: "สิ้นสุด",
  title19: "ใช้ตำแหน่งปัจจุบัน",
  title20: "ค้นหาเมือง",
  title21: "อุณหภูมิที่รู้สึกได้จริง",
  title22: "อุณหภูมิที่รู้สึกได้ในร่ม",
  title23: "ตอนนี้",
  title24: "วันนี้",
  title25: "อาทิตย์",
  title26: "จันทร์",
  title27: "อังคาร",
  title28: "พุธ",
  title29: "พฤหัส",
  title30: "ศุกร์",
  title31: "เสาร์",
  title32: "กำลังโหลด...",
  title33: "ตอนนี้",
  title34: "รายชั่วโมง",
  title35: "รายวัน",
  title36: "ดวงอาทิตย์ & ดวงจันทร์",
  title37: "คุณภาพอากาศ",
  title38: "ติดต่อ: xlf550402@gmail.com",
  title39: "ข้อตกลงความเป็นส่วนตัว",
  title40: "Copyright © comfortweather.com 2020 - 2025. All Right Reserved.",
  title41: "ข้อมูลโดย",
  title42: "สูง",
  title43: "ต่ำ",
  title44: "ยอมรับ",
  title45: "ขอบคุณที่ใช้ ComfortWeather และเพื่อปกป้องสิทธิ์ทางกฎหมายและผลประโยชน์ของคุณ โปรดอ่าน ",
  title46: "นโยบายความเป็นส่วนตัว",
  title47: " อย่างละเอียดก่อนใช้งาน",
  title48: "",
  title49: "ติดต่อ: xyjph123@gmail.com",
  title50: "Copyright © 24hweather.com 2020 - 2025. All Right Reserved.",
  title51: "ขอบคุณที่ใช้ 24hweather และเพื่อปกป้องสิทธิ์ทางกฎหมายและผลประโยชน์ของคุณ โปรดอ่าน ",
};
